














































































































































import {
  FETCH_USER_PROFILES_FUNCTIONALITIES,
  GET_LOGGED_USER,
  GET_LOGGED_USER_FUNCTIONALITIES,
  CREATE_LOGGED_USER,
} from '@/modules/home/store';
import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import AuthService from '@/services/AuthService';
import { IAuthUser } from '../models';
import { IFunctionality } from '@/modules/functionality/models';

const auth = new AuthService();

@Component
export default class extends Vue {

  @Getter(GET_LOGGED_USER)
  public authUser: IAuthUser;

}
